<template>
    <div :class="toggleClass">
        <button
            role="switch"
            type="button"
            tabindex="0"
            id="plans-switch"
            class="toggle-button"
            @click="onToggle">
            <span :class="isActiveClass('left')">
                {{ leftCopy }}
            </span>
            <span :class="isActiveClass('right')">
                {{ rightCopy }}
            </span>
            <span :class="getActiveClass" />
        </button>
    </div>
</template>

<script>
    import Product from 'aa/vue/models/Product';

    export default {
        event: 'toggle',
        data: function () {
            return {
                isRightActive: false,
                userHasEngaged: false,
            };
        },
        props: {
            defaultActive: {
                type: String,
                default: '',
            },
            leftCopy: {
                type: String,
                required: true,
                default: function () {
                    return '';
                },
            },
            rightCopy: {
                type: String,
                required: true,
                default: function () {
                    return '';
                },
            },
            toggleClass: {
                type: String,
                required: true,
                default: function () {
                    return 'toggle-button-wrapper';
                },
            },
        },
        computed: {
            getActiveClass() {
                return {
                    selected: true,
                    'selected-initial-left': !this.userHasEngaged && !this.isRightActive,
                    'selected-initial-right': !this.userHasEngaged && this.isRightActive,
                    'selected-left': this.userHasEngaged && !this.isRightActive,
                    'selected-right': this.userHasEngaged && this.isRightActive,
                };
            },
        },

        created() {
            this.isRightActive = this.defaultActive === Product.TYPE_ANNUAL.toUpperCase();
        },

        methods: {
            onToggle() {
                this.userHasEngaged = true;
                this.isRightActive = !this.isRightActive;

                this.$emit('toggle', this.isRightActive);
            },
            isActiveClass(side) {
                return {
                    active:
                        (side === 'left' && !this.isRightActive) ||
                        (side === 'right' && this.isRightActive),
                };
            },
        },
    };
</script>
